import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actionGetAssetStateMachine } from 'store/actions/assetsActions';

const useAssetStateMachine = () => {
  
  //get Helps wich are saved since web-management
  const { stateMachine } = useSelector((state) => state.assetsReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!Object.keys(stateMachine).length) {
        dispatch(actionGetAssetStateMachine());
    }
  }, [dispatch]);

  return stateMachine;
};

export default useAssetStateMachine;